// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"3278d352","360":"9c577c39","581":"bce887be","870":"56e3d36f"}[chunkId] + ".chunk.js";
};